import React, { useState, useEffect, useRef } from "react"; // useEffect, useRef 추가
import "../../../styles/templateFont.css"
import AdsHeaderImage from "../../../assets/components/AdsHeaderImage"
import { useNavigate } from "react-router-dom";
import PortalModal from "./detailComponents/PortalModal"
import AdsRecords from "./detailComponents/AdsRecords";

const AdsHome = ({ appData, tokenAll, onMyPhotoClick }) => {

    const navigate = useNavigate();
    const [popupImage, setPopupImage] = useState(null);

    // 등록 해제용 ref
    const unregisterModalCloserRef = useRef(null);
    const unregisterBackHandlerRef = useRef(null);

    const cleanupModalRegs = () => {
        if (unregisterModalCloserRef.current) {
            unregisterModalCloserRef.current();
            unregisterModalCloserRef.current = null;
        }
        if (unregisterBackHandlerRef.current) {
            unregisterBackHandlerRef.current();
            unregisterBackHandlerRef.current = null;
        }
    };

    const closePopup = () => {
        setPopupImage(null);
        // ★ 히스토리 조작 없이 등록만 해제 → 스플래시 없음
        cleanupModalRegs();
    };

    // 안전망: 모달이 사라지면 등록 해제
    useEffect(() => {
        if (!popupImage) {
            cleanupModalRegs();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [popupImage]);

    const navAutoPage = () => {
        if (!popupImage) return;
        const nextData = {
            ...appData, image_list: {
                path: popupImage.path,
                prompt: popupImage.prompt,
                design_id: popupImage.design_id,
            }
        };
        navigate(`/auto/marketing/prompt/loading`, { state: { data: nextData } });
    };


    const onCreate = () => {
        // navigate(`/auto/marketing/prompt/loading`, {
        navigate(`/manual/marketing/ai`, {
            state: appData
        });
    }

    return (
        <div className="flex h-full "
            style={{ paddingBottom: "68px" }}
        >
            {appData && (
                <div className="bg-white  w-full overflow-y-auto overflow-x-visible" >
                    <div className=''>
                        <AdsHeaderImage
                            imageList={appData.image_list}
                            data={appData}
                            tokenAll={tokenAll}
                            onPrimaryClick={onMyPhotoClick}
                        />

                        {popupImage && (
                            <PortalModal>
                                <div className="fixed inset-0 flex items-center justify-center bg-black/50">
                                    <div className="bg-white rounded-xl shadow-lg p-5 w-96 max-w-[92%]">
                                        <h2 className="text-lg font-semibold mb-3 text-center">광고 만들기</h2>

                                        {/* 확대 미리보기 */}
                                        <div className="w-full flex justify-center mb-4">
                                            <img
                                                src={popupImage.path}
                                                alt=""
                                                className="max-h-72 w-auto rounded-lg object-contain shadow-sm"
                                                draggable={false}
                                            />
                                        </div>

                                        <p className="pt-4 text-sm text-gray-700 text-center">
                                            해당 이미지를 토대로 생성하시겠습니까?
                                        </p>
                                        <p className="text-sm text-gray-700 text-center">
                                            생성 시 토큰이 차감됩니다.
                                        </p>

                                        {/* 버튼 */}
                                        <div className="mt-5 flex justify-center gap-3">
                                            <button
                                                onClick={closePopup}
                                                className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300"
                                            >
                                                취소
                                            </button>
                                            <button
                                                onClick={navAutoPage}
                                                className="px-4 py-2 rounded-lg bg-[#7864F9] text-white hover:bg-[#6750e0]"
                                            >
                                                확인
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </PortalModal>
                        )}
                        {/* 최근 7일 업로드 이미지 */}
                        <div className="w-full pt-[48px] px-[16px] pb-[32px]">
                            <AdsRecords
                                onCreateClick={onCreate}
                                tokenAll={tokenAll}
                            />
                        </div>

                    </div>

                </div>
            )}
        </div>
    );
};

export default AdsHome;
